$(document).on('ready', function () {
    // We continue to check for when the add on plugin adds the button to add item to cart. If it goes 5 seconds without it being loaded, we kill this button handler
    let intervalLength = 0;
    var interval = setInterval(function () {
        if (($('.bttn').length) || (intervalLength >= 5000)) {
            $('.bttn').on('click', function () {
                // This override applies to the cart upsell app - if they click the add button, this makes localstorage force the user to re-apply.
                localStorage.removeItem('applyrebatesbtn_disable');
            });
            clearInterval(interval);
        }
        intervalLength += 1000;
    }, 1000);
});
